import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomerForm, {
  CustomerFormFields,
} from '../../components/Customer/CustomerForm';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';
import PersonType from '../../enums/PersonType';

export default function CustomersNew() {
  const {
    user: { organization },
  } = useAuth();
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});

  const onSubmit = async (data: CustomerFormFields) => {
    try {
      const { alias, ...rest } = data;

      const response = await api.post(
        `organizations/${organization.id}/customers`,
        {
          alias: Number(data.type) === PersonType.Juridical ? alias : undefined,
          ...rest,
        }
      );

      const { id } = response.data;

      navigate(`/customers/${id}/edit`);
    } catch (e: any) {
      if (e?.response?.data?.errors) {
        setFormErrors(e.response.data.errors);
      } else {
        throw e;
      }
    }
  };

  const [formFields, setFormFields] = useState<CustomerFormFields>(
    {} as CustomerFormFields
  );

  return (
    <CustomerForm
      isLoading={1 + 1 === 1}
      title='Novo cliente'
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
